import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const PUBLIC_URL = process.env.PUBLIC_URL;

const Header = ({ sections }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleScroll = (event, id) => {
    event.preventDefault();

    if (location.pathname === '/') {
      const targetElement = document.getElementById(id);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(`/#${id}`);
    }
  };

  return (
    <header className="header">
      <div className="header-left">
        <div className="logo">
          <Link to="/" onClick={(e) => handleScroll(e, 'hero')}>
            <img src={`${PUBLIC_URL}/images/logo/logo1.svg`} alt="Logo da empresa" />
          </Link>
        </div>
        <div>
          <h3><strong>SOLUÇÕES</strong></h3>
          <p>Mobiliário para bares, hotéis, restaurantes e condomínios</p>
        </div>
      </div>
      <nav className="nav">
        <ul>
          {sections.map((section) => (
            <li key={section.id}>
              <a 
                href={`#${section.id}`} 
                onClick={(e) => handleScroll(e, section.id)}
              >
                {section.name}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default Header;